export default __webpack_public_path__ + "static/media/Contact.3e929dfd.png";